import React, { Ref, forwardRef, useMemo } from 'react';
import { classNames } from 'primereact/utils';
import './Divider.scss';

export type DividerVariant = 'grey';

export type DividerVariantSize = 'sm';

export type DividerProps = {
	margin?: number;
	variant?: DividerVariant;
	variantSize?: DividerVariantSize;
	horizontal?: boolean;
	className?: string;
};

export const Divider = forwardRef(
	(
		{ margin = 1, variant = 'grey', variantSize = 'sm', horizontal = false, className, ...restProps }: DividerProps,
		ref: Ref<HTMLDivElement>
	) => {
		const finalClassName = useMemo(
			() =>
				classNames(
					'divider',
					`divider-variant-${variant}`,
					`divider-size-${variantSize}`,
					`my-${margin}`,
					{
						[`divider-horizontal`]: horizontal,
					},
					className
				),
			[variant, variantSize, margin, horizontal, className]
		);
		return <div ref={ref} className={finalClassName} {...restProps} />;
	}
);
